import { LANGUAGE_FILTER_ALL } from '@/shared/config';

export const listLanguagesWithSelected = (
  availableLanguages: string[],
  selected: string,
): string[] =>
  selected === LANGUAGE_FILTER_ALL || availableLanguages.includes(selected)
    ? availableLanguages
    : [selected, ...availableLanguages];
